export default __webpack_public_path__ + "static/media/add-project.39b53c29.svg";